module.exports = __webpack_public_path__ + "static/media/ruler-horizontal.77f9ac06.svg";